import { render, staticRenderFns } from "./Cooling.vue?vue&type=template&id=13aad8c4&scoped=true&"
import script from "./Cooling.vue?vue&type=script&lang=js&"
export * from "./Cooling.vue?vue&type=script&lang=js&"
import style0 from "./Cooling.vue?vue&type=style&index=0&id=13aad8c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aad8c4",
  null
  
)

export default component.exports